<template>
  <div class="field-wrapper" :data-type="data.Type" v-show="isVisible">
    <template>
      <FieldScreen
        ref="field"
        :data="data"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        v-if="data.Type == PreApproveMe.fieldTypes.Screen"
      />
      <FieldHubScreen
        ref="field"
        :data="data"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        v-else-if="data.Type == PreApproveMe.fieldTypes.HubScreen"
      />
      <FieldGroup
        ref="field"
        :data="data"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        v-else-if="data.Type == PreApproveMe.fieldTypes.Group"
      />
      <FieldRepeatingGroup
        ref="field"
        :data="data"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        v-else-if="data.Type == PreApproveMe.fieldTypes.RepeatingGroup"
      />
      <FieldBasicInfo
        ref="field"
        :data="data"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        v-else-if="data.Type == PreApproveMe.fieldTypes.BasicUserInformation"
      />
      <FieldAddress
        ref="field"
        :data="data"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        v-else-if="data.Type == PreApproveMe.fieldTypes.Address"
      />
      <FieldButton
        ref="field"
        :data="data"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        v-else-if="data.Type == PreApproveMe.fieldTypes.Button"
      />
      <FieldInput
        ref="field"
        :data="data"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        @field:created="evtCreated"
        @field:input="evtInput"
        @field:suggestion="evtSuggestion"
        v-else-if="PreApproveMe.isInput(data.Type)"
      />
      <div class="unknown-field" :data-fieldid="data.Id" v-else>
        {{ data.Type }}: <Localize :text="data.Text" />
      </div>
      <FieldFooter
        ref="field"
        :data="data"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        v-if="data.Footer && data.Footer.length > 0"
      />
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import PreApproveMe from '@/services/PreApproveMe.js'

import FieldAddress from '@/components/FieldAddress.vue'
import FieldBasicInfo from '@/components/FieldBasicInfo.vue'
import FieldButton from '@/components/FieldButton.vue'
import FieldFooter from '@/components/FieldFooter.vue'
import FieldGroup from '@/components/FieldGroup.vue'
import FieldInput from '@/components/FieldInput.vue'
import FieldRepeatingGroup from '@/components/FieldRepeatingGroup.vue'
import FieldScreen from '@/components/FieldScreen.vue'
import FieldHubScreen from '@/components/FieldHubScreen.vue'

import Localize from '@/components/Localize.vue'

export default {
  name: 'Field',
  components: {
    FieldAddress,
    FieldBasicInfo,
    FieldButton,
    FieldFooter,
    FieldGroup,
    FieldInput,
    FieldRepeatingGroup,
    FieldScreen,
    FieldHubScreen,
    Localize
  },
  props: {
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String
  },
  data: () => {
    return {
      PreApproveMe,
      requirementSatisfied: false
    }
  },
  computed: {
    isVisible: function () {
      if (this.data.Visibility === 1)
        return false
      if (this.data.Visibility === 3)
        return false
      if (this.data.RequiredFields && !this.requirementSatisfied)
        return false

      return true
    }
  },
  methods: {
    evtValid: function($event) {
      this.$emit('field:isvalid', $event)
    },
    evtFocused: function($event) {
      this.$emit('field:isfocused', $event)
    },
    evtValue: function($event) {
      this.$emit('field:value', $event)
    },
    evtChange: function($event) {
      this.$emit('field:change', $event)
    },
    evtDelete: function($event) {
      this.$emit('field:delete', $event)
    },
    evtCreated: function($event) {
      this.$emit('field:created', $event)
    },
    evtInput: function($event) {
      this.$emit('field:input', $event)
    },
    evtSuggestion: function($event) {
      this.$emit('field:suggestion', $event)
    },
    checkRequireFields: function() {
      // if inside a repeating group, requirements should refer to the same repeating group item
      var repeatingGroupIndex = this.getRepeatingGroupIndex()

      const $this = this
      let reqSatisfied = true
      for (let i = 0; i < (this.data.RequiredFields || []).length; i++) {
        const currReq = this.data.RequiredFields[i]
        if (typeof this.$store.state.saveData[this.$store.state.borrowerid][currReq.FieldId + repeatingGroupIndex] !== 'undefined') {
          const fieldVal = this.$store.state.saveData[this.$store.state.borrowerid][currReq.FieldId + repeatingGroupIndex]
          //if (currReq.RequiredValue) {
            // if (currReq.NotValue && fieldVal == currReq.RequiredValue)
            //   console.log(
            //     'Invalid requirement: ' +
            //       fieldVal +
            //       ' == ' +
            //       currReq.RequiredValue
            //   )
            // else
            //   console.log(
            //     'Valid requirement: ' +
            //       fieldVal +
            //       ' != ' +
            //       currReq.RequiredValue
            //   )
            // if (!currReq.NotValue && fieldVal !== currReq.RequiredValue)
            //   console.log(
            //     'Invalid requirement: ' +
            //       fieldVal +
            //       ' != ' +
            //       currReq.RequiredValue
            //   )
            // else
            //   console.log(
            //     'Valid requirement: ' +
            //       fieldVal +
            //       ' == ' +
            //       currReq.RequiredValue
            //   )
            if ((currReq.NotValue && (fieldVal + '') == currReq.RequiredValue) || (!currReq.NotValue && (fieldVal + '') != currReq.RequiredValue)) {
              reqSatisfied = false
            }
          //}
        } else {
          if (!currReq.NotValue) {
            reqSatisfied = false
          }
        }
      }

      if (reqSatisfied !== this.requirementSatisfied) {
        $this.$root.$emit('slider:update')
        setTimeout(() => {
          $this.$root.$emit('slider:update')
        }, 350)
        setTimeout(() => {
          $this.$root.$emit('slider:update')
        }, 100)
      }
      this.requirementSatisfied = reqSatisfied
    },
    getRepeatingGroupIndex: function () {
      var index = ""

      var parts = (this.data.Id || '').split('__')
      if (parts.length > 1)
        index = parts[1] * 1

      if (isNaN(index))
        index = ""

      if (typeof index === 'number')
        index = "__" + index

      return index
    }
  },
  created: function() {
    if (this.data.RequiredFields) {
      var repeatingIndex = this.getRepeatingGroupIndex()
      for (let i = 0; i < this.data.RequiredFields.length; i++) {
        const currReq = this.data.RequiredFields[i]
        this.$root.$on(
          'depend:update:' + currReq.FieldId + repeatingIndex,
          this.checkRequireFields
        )

        this.$root.$on('borrower:change', this.checkRequireFields)

        this.$root.$on('form:update', this.checkRequireFields)

        //this.$root.$on('field:input', this.checkRequireFields)
      }

      // First run
      this.checkRequireFields()
    }
  }
}
</script>

<style scoped lang="scss">
.field-wrapper {
  &.hidden {
    display: none;
  }
}
</style>
